import { httpDelete, httpGet, httpPatch, httpPost } from "../connection";

export async function getCaseTypes() {
  return await httpGet(`/case-types`);
}

export async function createCaseType(values: { case_type: string }) {
  return await httpPost(`/case-types`, values);
}

export async function updateCaseType(case_type_id: number, values = {}) {
  return await httpPatch(`/case-types/${case_type_id}`, values);
}

export async function deleteCaseType(id: number, options = { replace: null }) {
  if (options.replace == null) return await httpDelete(`/case-types/${id}`);
  else if (options.replace != null)
    return await httpDelete(`/case-types/${id}?replace=${options.replace}`);
}

const CaseTypesApi = {
  getCaseTypes,
  createCaseType,
  updateCaseType,
  deleteCaseType,
};

export default CaseTypesApi;
